<template>
  <div>
    <v-row no-gutters>
      <v-col :cols="12" class="px-1">
        <dd-sub-header>
          給油金額実績と全国指標給油金額の推移
        </dd-sub-header>
      </v-col>
    </v-row>
    <v-row  no-gutters>
      <v-col :cols="12" class="px-1">
        <dd-chart-line-bar
          titleText=""
          :chartHeight="chartHeight"
          :showToolbar="true"
          :zoomEnabled="true"
          :distributedColor="false"
          :showLegend="true"
          labelFormatType="num"
          :dataSource="dataSource"
          ref="ddChartLineBar"
        ></dd-chart-line-bar>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import flowMixin from '@/mixins/flowMixins'
// import filter from '@/rahmen/utils/filters'
import DdSubHeader from '@/components/DdSubHeader'
import DdChartLineBar from '@/components/DdChartLineBar'
// import date from '@/ddv2.library/date'

export default {
  name: 'DdNenpiChartLineBar',
  mixins: [flowMixin],
  props: {
    /**
     * 抽出対象車両所属営業所IdList
     */
    eigyoshoIdList: Array,
    /**
     * 抽出対象燃費カテゴリIdList
     */
    nenpiCategoryIdList: Array,
    /**
     * 高さ
     */
    chartHeight: {
      type: String,
      default: '350'
    }
  },
  components: {
    DdChartLineBar,
    DdSubHeader
  },
  data: () => ({
    dataList: [],
    dataSource: [
      {
        name: '給油実績金額',
        type: 'column',
        data: [],
        color: '#6495ed'
      }, {
        name: '全国指標金額',
        type: 'line',
        data: [],
        color: '#696969'
      }
    ]
  }),
  created () {
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    // このコンポーネント自身でAPIにリクエストを投げるときに使用
    searchNenkanHensachi: function (from, to) {
      const self = this
      if ([undefined, null, ''].includes(from) || [undefined, null, ''].includes(to)) { return }
      const rec = {
        searchTargetStartYmdString: from,
        searchTargetEndYmdString: to
      }
      self.HttpClient.post('/api/v1/D2FUED0040/KyuyuJissekiNenkanHensachiSearch', rec)
        .then((data) => {
          self.dataList = data.payload
          self.calcDispKingaku(self.eigyoshoIdList, self.nenpiCategoryIdList)
        })
    },
    setDataListFromMainVue: function (searchTargetEndYmdString, eigyoshoIdList, nenpiCategoryIdList, nenkanHensachiDataList) {
      const self = this
      self.dataList = Object.assign([], nenkanHensachiDataList)
      self.calcDispKingaku(searchTargetEndYmdString, eigyoshoIdList, nenpiCategoryIdList)
    },
    calcDispKingaku: function (searchTargetEndYmdString, eigyoshoIdList, nenpiCategoryIdList) {
      const self = this
      // 表示対象の年月リストを取得する。
      const searchTargetEndYmd = new Date(searchTargetEndYmdString)
      const searchTargetEndFirstYmd = new Date(searchTargetEndYmd.getFullYear(), searchTargetEndYmd.getMonth(), 1)
      const dispYmStringList = []
      for (let i = 0; i < 12; i++) {
        const calcStartYmd = new Date(searchTargetEndFirstYmd)
        const targetDate = new Date(calcStartYmd.setMonth(calcStartYmd.getMonth() - i))
        const Y = targetDate.getFullYear()
        const M = ('00' + (targetDate.getMonth() + 1)).slice(-2)
        const targetYmString = Y + '/' + M
        dispYmStringList.unshift(targetYmString)
      }
      let targetList = Object.assign([], self.dataList)
      console.log(eigyoshoIdList)
      if (eigyoshoIdList.length > 0) {
        targetList = self.dataList.filter(function (elem) {
          return eigyoshoIdList.includes(elem.eigyoshoId)
        })
      }
      if (nenpiCategoryIdList.length > 0) {
        targetList = self.dataList.filter(function (elem) {
          return nenpiCategoryIdList.includes(elem.nenpiCategoryId)
        })
      }
      const resultList = targetList.reduce((result, current) => {
        const element = result.find((p) => p.yearMonth === current.yearMonth)
        if (element) {
          element.kyuyuKingakuJissekiKei += current.kyuyuKingakuJissekiKei
          element.zenkokuShihyoKingaku += current.zenkokuShihyoKingaku
        } else {
          result.push({
            yearMonth: current.yearMonth,
            kyuyuKingakuJissekiKei: current.kyuyuKingakuJissekiKei,
            zenkokuShihyoKingaku: current.zenkokuShihyoKingaku
          })
        }
        return result
      }, [])
      const kyuyuKingakuJissekiList = []
      const zenkokuShihyoKingakuList = []
      for (let i = 0; i < dispYmStringList.length; i++) {
        const param = resultList.find((t) => {
          return t.yearMonth === dispYmStringList[i]
        })
        const kyuyuKingakuJisseki = { x: dispYmStringList[i], y: param ? param.kyuyuKingakuJissekiKei : 0 }
        const zenkokuShihyoKingaku = { x: dispYmStringList[i], y: param ? param.zenkokuShihyoKingaku : 0 }
        kyuyuKingakuJissekiList.push(kyuyuKingakuJisseki)
        zenkokuShihyoKingakuList.push(zenkokuShihyoKingaku)
      }
      const dispDataList = [
        {
          name: '給油実績金額',
          type: 'column',
          data: kyuyuKingakuJissekiList,
          color: '#6495ed'
        }, {
          name: '全国指標金額',
          type: 'line',
          data: zenkokuShihyoKingakuList,
          color: '#696969'
        }
      ]
      console.log(dispDataList)
      self.$refs.ddChartLineBar.updateDispData(dispDataList)
    }
  }
}
</script>
<style scoped>
</style>
